import { ParametersDataResponseRequest } from 'src/app/pages/admin-manager/parameters/models/parameters.model';
import { ParametersEnum } from '@shared/enums/parameters.enum';

// Parámetros generales por país
export function getCountryGeneralParameters(countryId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'RMS_OT_DEL_DATE',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMS_OT_DEL_TIME',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_READYMIX_TRUCKVOL',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_READYMIX_SALESORG',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
  ];
}

// Parámetro de tiempo de expiración por subgrupo
export function getSubGroupParameters(subGroupId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'RMS_MEP_MINCHECK',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
    {
      parameterCode: 'DFLT_EXP_TIME',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
    {
      parameterCode: ParametersEnum.COPY_INTERNAL_INFORMATION,
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
    {
      parameterCode: 'RC3_SEARCH_METH',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
  ];
}

// Parámetros de contrato y estado por subgrupo
export function getSubGroupContractAndStatusParameters(subGroupId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'ARKIK_OT_CONTRACT_FIELDS',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
    {
      parameterCode: 'RMS_OT_HS_STATUS',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
    {
      parameterCode: 'RC3_SEARCH_METH',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
  ];
}

// Parámetros varios por subgrupo y globales
export function getSubGroupAndGlobalParameters(countryId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'RMS_OT_OPEN_ORD',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMS_OT_SKIP_AGR',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DCPL_COM_MOD',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'DFLT_CHANNEL_CODE',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'DFLT_READYMIX_SALESORG',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'DFLT_READYMIX_DISTCHAN',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'DFLT_READYMIX_DIVISION',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'RC3_TOLERANCE_OV',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'VARIABLE_DOSAGE',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'LOAD_SPECIFIC',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'RMS_MEP_MINCHECK',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_DISTANCE_UOM',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_WEIGHT_UOM',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMS_MEP_MINCHECK',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_DISTANCE_UOM',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_WEIGHT_UOM',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMS_MEP_MINCHECK',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'CONCRETE_MAX_VOL',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'OLS_BIGORD_VOL',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'DFLT_EXPDAT_REFDOC',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    {
      parameterCode: 'DFLT_READYMIX_UOM',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'ORDERS_DELIVERYTIME_TOLERANCE',
      scopeId: null,
      parameterScopeTypeId: 5,
    },
    { parameterCode: ParametersEnum.DFLT_ORDER_SPACING, scopeId: countryId, parameterScopeTypeId: 4 },
    // Pump Primer (ARKIK-38060 / ARKIK-38070) — market scope
    {
      parameterCode: 'RMX_DCOD_PRIMERT',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMX_DCOD_PRIMERQ',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMX_PUMP_PRIMER_QTY_DFLT',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'ARKIK_PP_MIN_ARRIVAL',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'ARKIK_PP_MAX_ARRIVAL',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMS_LOAD_BALANCING',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
  ];
}

// Parámetro de edición de tiempo de viaje por subgrupo
export function getEditTravelTimeParameter(subGroupId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'ARKIK_OT_EDIT_TRAVEL_TIME',
      scopeId: subGroupId,
      parameterScopeTypeId: 2,
    },
  ];
}

// Parámetros de organización de ventas y códigos por país
export function getCountrySalesOrgAndCodesParameters(countryId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'DFLT_READYMIX_SALESORG',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMX_DCOD_CO_YDAY',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMX_DCOD_CO_XDAY',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
    {
      parameterCode: 'RMX_DCOD_CO_NSL',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
  ];
}

// Parámetro de moneda por país
export function getCountryCurrencyCodeParameter(countryId: number): ParametersDataResponseRequest[] {
  return [
    {
      parameterCode: 'DFLT_CURRENCY_CODE',
      scopeId: countryId,
      parameterScopeTypeId: 4,
    },
  ];
}

// Función principal que compone todas
export function getCountryParametersDataResponseRequestList(
  countryId: number,
  subGroupId: number = null,
): ParametersDataResponseRequest[] {
  const all = [
    ...getCountryGeneralParameters(countryId),
    ...getSubGroupParameters(subGroupId),
    ...getSubGroupContractAndStatusParameters(subGroupId),
    ...getSubGroupAndGlobalParameters(countryId),
    ...getEditTravelTimeParameter(subGroupId),
    ...getCountrySalesOrgAndCodesParameters(countryId),
    ...getCountryCurrencyCodeParameter(countryId),
  ];
  // Elimina duplicados por parameterCode, scopeId y parameterScopeTypeId
  const seen = new Set<string>();
  return all.filter((param) => {
    const key = `${param.parameterCode}|${param.scopeId}|${param.parameterScopeTypeId}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

// Solo parámetros con scopeType 4 y 5 (deduplicados)
export function getCountryParametersScopeType4And5List(
  countryId: number,
  subGroupId: number = null,
): ParametersDataResponseRequest[] {
  return getCountryParametersDataResponseRequestList(countryId, subGroupId).filter((p) => {
    const scopeType = Number(p.parameterScopeTypeId);
    return scopeType === 4 || scopeType === 5;
  });
}
